// ── App Preview (in-dashboard TV frame over /app/v1) ──
//
// D-2.6 transport: the preview fetches the PUBLIC /app/v1 contract directly
// from the platform content host, resolving tenancy with the same
// x-app-customer-domain header the Roku shell itself sends (SHApiBase +
// SHAppDomain). The content host serves /app/v1 with permissive CORS, so no
// dashboard-side proxy exists — keep it that way.

export const APP_PREVIEW_CONTENT_HOSTS = {
  streamhoster: 'https://c.streamhoster.com',
  whitelabel: 'https://c.themediacdn.com',
} as const;

export const APP_PREVIEW_TENANT_HEADER = 'x-app-customer-domain';

/** Platform param for preview fetches — the preview simulates the Roku shell. */
export const APP_PREVIEW_PLATFORM = 'roku';

export const APP_PREVIEW_QUERY_KEYS = {
  all: ['appPreview'] as const,
  cfg: (domain: string) => [...APP_PREVIEW_QUERY_KEYS.all, 'cfg', domain] as const,
  browse: (domain: string) => [...APP_PREVIEW_QUERY_KEYS.all, 'browse', domain] as const,
} as const;
